/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
const config = {
  authServerHost: process.env.REACT_APP_AUTH_SERVER_HOST || "http://localhost:6443",
  baseURL: process.env.REACT_APP_API_URL || "https://apidev.fenixoutdoor.com/api",
  ocpApimSubscriptionKey: process.env.REACT_APP_API_KEY || "0e0aa6d946a240d5a2bdec126b6f98c1",
};

export default config;
